import { render, staticRenderFns } from "./DashboardUI.vue?vue&type=template&id=454ed514&scoped=true&"
import script from "./DashboardUI.vue?vue&type=script&lang=js&"
export * from "./DashboardUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454ed514",
  null
  
)

export default component.exports